import { Tooltip as ReactTooltip } from 'react-tooltip'
import styles from './index.module.scss'

interface TooltipProps {
  id: string
}

/**
 * Wrapper on top of react-tooltip
 * @see https://react-tooltip.com/docs/getting-started
 */
export const Tooltip: React.FC<TooltipProps> = ({ id }) => {
  return (
    <ReactTooltip
      id={ id }
      className={ styles['tooltip'] }
    />
  )
}
